import React from 'react';
import IconInstagram from './IconInstagram';

type IconProps = {
    width?: number;
    height?: number;
    color?: string;
};

const IconIstagramComment: React.FC<IconProps> = ({ width = 22, height = 21, color = '#000' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 22 21"
            fill="none"
        >
            <g clip-path="url(#clip0_10468_178)">
                <path
                    d="M18.4559 2.51148C16.5124 0.891918 13.9352 0 11.1989 0C8.46273 0 5.8855 0.891918 3.94202 2.51148C1.96674 4.15757 0.878906 6.35561 0.878906 8.7008C0.878906 10.0893 1.27566 11.4705 2.02629 12.6949C2.68987 13.7773 3.63258 14.744 4.76505 15.5063V20.0354C4.76505 20.28 4.91239 20.5004 5.13834 20.594C5.21316 20.625 5.29173 20.6401 5.36962 20.6401C5.527 20.6401 5.68164 20.5787 5.79733 20.463L9.04827 17.2121C9.75326 17.3379 10.4752 17.4016 11.199 17.4016C13.9352 17.4016 16.5124 16.5097 18.4559 14.8901C20.4312 13.244 21.519 11.046 21.519 8.70076C21.519 6.35557 20.4312 4.15757 18.4559 2.51148ZM11.1989 16.1923C10.4463 16.1923 9.69641 16.116 8.97018 15.9655C8.7708 15.9244 8.56395 15.9861 8.41995 16.1301L5.97443 18.5756V15.1781C5.97443 14.9698 5.8672 14.7761 5.69059 14.6656C3.40127 13.2325 2.08829 11.0584 2.08829 8.7008C2.08829 4.57 6.17531 1.20938 11.1989 1.20938C16.2226 1.20938 20.3096 4.57 20.3096 8.7008C20.3096 12.8316 16.2226 16.1923 11.1989 16.1923Z"
                    fill={color}
                />
            </g>
            <defs>
                <clipPath id="clip0_10468_178">
                    <rect
                        width="20.6401"
                        height="20.6401"
                        fill={color}
                        transform="translate(0.878906)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export default IconIstagramComment;
